<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle2"><a id="page_vi"></a><a id="illus"></a>ILLUSTRATIONS</h1>
<p class="toc2"><a href="#/09_chapter01#fig1">The Oath of the Enchantment</a></p>
<p class="toc2"><a href="#/09_chapter01#fig2">The Chakras</a></p>
<p class="toc2"><a href="#/09_chapter01#fig3">The Averse Invoking Pentagrams</a></p>
<p class="toc2"><a href="#/09_chapter01#fig4">The Unicursal Hexagram</a></p>
<p class="toc2"><a href="#/09_chapter01#fig5">The Mark of the Beast</a></p>
<p class="toc2"><a href="#/09_chapter01#fig6">The NOX Signs</a></p>
<p class="toc2"><a href="#/09_chapter01#fig7">The Spiral Dance 1 &amp; 2</a></p>
<p class="toc2"><a href="#/09_chapter01#fig8">The Sign of the Enterer</a></p>
<p class="toc2"><a href="#/09_chapter01#fig9">The Sign of Silence</a></p>
<p class="toc2"><a href="#/10_chapter02#fig10">The LVX Signs</a></p>
<p class="toc2"><a href="#/10_chapter02#fig11">Rosary</a></p>
<p class="toc2"><span href="#/11_chapter03#fig12" title="Link target outside of Sample">Nepthys, Isis, Harpocrates, Horus, Osiris</span></p>
<p class="toc2"><span href="#/12_chapter04#fig13" title="Link target outside of Sample">Floorplan - A Ritual to Invoke HICE</span></p>
<p class="toc2"><span href="#/13_chapter05#fig14" title="Link target outside of Sample">Floorplan - A Rite of Isis</span></p>
<p class="toc2"><span href="#/13_chapter05#fig15" title="Link target outside of Sample">Maat, Hathor</span></p>
<p class="toc2"><span href="#/14_chapter06#fig16" title="Link target outside of Sample">Tauroctony</span></p>
<p class="toc2"><span href="#/14_chapter06#fig17" title="Link target outside of Sample">The seven Degree symbols of Mithraism</span></p>
<p class="toc2"><span href="#/14_chapter06#fig18" title="Link target outside of Sample">Floorplan - A Mithraic Liturgy</span></p>
<p class="toc2"><span href="#/15_chapter07#fig19" title="Link target outside of Sample">Maenad</span></p>
<p class="toc2"><span href="#/16_chapter08#fig20" title="Link target outside of Sample">Floorplan - Goetia</span></p>
<p class="toc2"><span href="#/17_chapter09#fig21" title="Link target outside of Sample">Floorplan - The Brazen Head</span></p>
<p class="toc2"><span href="#/17_chapter09#fig22" title="Link target outside of Sample">The Sigil of Belial</span></p>
<p class="toc2"><span href="#/18_chapter10#fig23" title="Link target outside of Sample">Floorplan - An Evocation of Bartzabel the Spirit of Mars</span></p>
<p class="toc2"><span href="#/18_chapter10#fig24" title="Link target outside of Sample">The 1st Talisman of Mars</span></p>
<p class="toc2"><span href="#/18_chapter10#fig25" title="Link target outside of Sample">The 3rd Talisman of Mars</span></p>
<p class="toc2"><span href="#/18_chapter10#fig26" title="Link target outside of Sample">The 5th Talisman of Mars</span></p>
<p class="toc2"><span href="#/20_chapter12#fig27" title="Link target outside of Sample">Seal of Cagliostro</span></p>
<p class="toc2"><span href="#/20_chapter12#fig28" title="Link target outside of Sample">Floorplan - Ritual of Consecration of an High Priest of L.I.L.</span></p>
<p class="toc2"><span href="#/21_chapter13#fig29" title="Link target outside of Sample">Floorplan - Ritual of Initiation of a Thelemite</span></p>
<p class="toc2"><span href="#/22_chapter14#fig30" title="Link target outside of Sample">Floorplan - Breaking of Bread</span></p>
<p class="toc2"><span href="#/24_appendixi#fig31" title="Link target outside of Sample">The Banishing Pentagram of Earth</span></p>
<p class="toc2"><span href="#/24_appendixi#fig32" title="Link target outside of Sample">The Elemental Hexagrams</span></p>
<p class="toc2"><span href="#/25_appendixii#app-ii" title="Link target outside of Sample">The Seals of the 72 Spirits of the Goetia</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_illustrations.vue?be718818